module.exports = __webpack_public_path__ + "img/icon_identity_card4.f00faffc.png";